import React from "react";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import { Page } from "./types";
import ScrollToTop from "./ScrollToTop";
import Footer from "shared/Footer/Footer";
import Page404 from "containers/Page404/Page404";
import PageContact from "containers/PageContact/PageContact";
import PageAbout from "containers/PageAbout/PageAbout";
import PageSubcription from "containers/PageSubcription/PageSubcription";
import SiteHeader from "containers/SiteHeader";
import PageHome2 from "containers/PageHome/PageHome2";
import PageSearch from "containers/PageServices/PageSearch";
import PageCustomers from "containers/PageCustomers/PageCustomers";
import PagePoliticsPrivate from "containers/Politics&Privacite/PagePolitics&Priv";
import PagePoliticsCookies from "containers/PoliticsCookies/PagePoliticsCookies";


export const pages: Page[] = [
  { path: "/", exact: true, component: PageHome2 },
  { path: "/contact", component: PageContact },
  { path: "/about", component: PageAbout },
  { path: "/subscription", component: PageSubcription },
  { path: "/planes", component: PageSubcription },
  { path: "/customers", component: PageCustomers },
  { path: "/politicas-de-privacidad", component: PagePoliticsPrivate },
  { path: "/politicas-de-cookies", component: PagePoliticsCookies },
];

const Routes = () => {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <SiteHeader />
      <Switch>
        {pages.map(({ component, path, exact }) => {
          return (
            <Route
              key={path}
              component={component}
              exact={!!exact}
              path={path}
            />
          );
        })}
        <Route component={Page404} />
      </Switch>
      <Footer />
    </BrowserRouter>
  );
};

export default Routes;
